// @ts-nocheck
import * as React from "react";

const Login: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M19 4a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 110-2h1V6h-1a1 1 0 110-2zm-8.6 3.2a1 1 0 011.4.2l3.02 4.02a1 1 0 010 1.18l-2.82 4a1 1 0 01-.81.42l-.124-.007a1 1 0 01-.456-.173l-.004-.003a1 1 0 01-.236-1.397L12.09 13H4a1 1 0 110-2h8l-1.8-2.4a1 1 0 01.2-1.4z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Login);
